import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyPolicyTypeService } from '../../../Model/CompanyPolicyType/company-policy-type.service';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CommonService } from '../../../Model/Common/common.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';

@Component({
  selector: 'app-company-policy-type-form',
  standalone: true,
  imports: [FormsModule, CommonModule],
  templateUrl: './company-policy-type-form.component.html',
  styleUrl: './company-policy-type-form.component.scss'
})
export class CompanyPolicyTypeFormComponent {
  isDisabled: boolean = false;
  activeModal = inject(NgbActiveModal);
  @Input() ID!: number;

  CompanyPolicyTypeDetail = {
    ESS_CompanyPolicyTypeMasterID: 0,
    ESS_CompanyPolicyTypeTitle: null,
    SelectType: 'insert',
  }
  constructor(
    private modalService: NgbModal,
    private companyPolicyType: CompanyPolicyTypeService,
    //private dialog: MatDialog,
    private toast: ToastService,
    protected common: CommonService,
    private tooltip: TooltipService,
  ) {
    this.common.getPageRights();
    this.CompanyPolicyTypeDetail.ESS_CompanyPolicyTypeMasterID = this.ID;
  }

  ngOnInit(): void {
    if (this.ID > 0) {
      this.GetCompanyPolicyType();
    }
  }

  GetCompanyPolicyType() {
    this.isDisabled = true;
    this.CompanyPolicyTypeDetail.ESS_CompanyPolicyTypeMasterID = this.ID;
    this.companyPolicyType.GetCompanyPolicyType({ ESS_CompanyPolicyTypeMasterID: this.CompanyPolicyTypeDetail.ESS_CompanyPolicyTypeMasterID, SelectType: 1 }).subscribe({
      next: (response) => {
        this.CompanyPolicyTypeDetail.ESS_CompanyPolicyTypeTitle = response.Table[0].ESS_CompanyPolicyTypeTitle;
        this.CompanyPolicyTypeDetail.SelectType = 'update';
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  async SaveCompanyPolicyType() {
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Do you want save?'
    modalRef.result.then((result: any) => {
      if ((this.common.PageRight.IsAdd && this.ID == 0) || (this.common.PageRight.IsEdit && this.ID > 0)) {
        if (result) {
          this.isDisabled = true;
          this.CompanyPolicyTypeDetail.ESS_CompanyPolicyTypeMasterID = this.ID;
          this.companyPolicyType.SaveCompanyPolicyType(this.CompanyPolicyTypeDetail).subscribe({
            next: (response) => {
              if (response.Error_Code == '01') {
                this.activeModal.close(true);
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
              } else {
                this.toast.show({ message: response.Error_Message, type: toastTypeEnum.danger });
              }
              this.isDisabled = false;
            },
            complete: () => { },
            error: (error) => {
              this.isDisabled = false;
            },
          });
        }
      } else {
        this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
      }
    }).catch(() => {
      // Modal dismissed
    });

  }

  close() {
    this.activeModal.close();
  }

}
